import { render, staticRenderFns } from "./MakeSecure.html?vue&type=template&id=67d6dc11&scoped=true&"
import script from "./MakeSecure.js?vue&type=script&lang=js&"
export * from "./MakeSecure.js?vue&type=script&lang=js&"
import style0 from "./MakeSecure.scss?vue&type=style&index=0&id=67d6dc11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6dc11",
  null
  
)

export default component.exports